import React, { useCallback } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js';
import { useRegistrationStore } from '../../../store/registrationStore';
import useEventDetails from '../../../hooks/useEventDetails';
import { useEventContext } from '../../../context/EventProvider';

// Call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(process.env.GATSBY_STRIPE_EMBED_PK || '');

const PaymentStep = () => {
  const { userData, updateUserData } = useRegistrationStore();
  const { event } = useEventContext();
  const { eventId, checkoutUrl } = useEventDetails();

  const strapiEventId = JSON.parse(event.internal.content).id || eventId;

  const fetchClientSecret = useCallback(() => {
    const quantity = 1;
    const ticketTypeId = userData.ticketTypeStep?.ticketTypeId;

    return fetch(checkoutUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ eventID: strapiEventId, quantity, ticketTypeID: ticketTypeId }),
    })
      .then((res) => res.json())
      .then((data) => {
        updateUserData('paymentStep', { initiated: true, completed: false });
        return data.clientSecret;
      });
  }, [updateUserData, userData, strapiEventId, checkoutUrl]);

  const options = { fetchClientSecret };

  return (
    <div id="checkout">
      <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export default PaymentStep;
